import backArrow from '../../../../../assets/img/backArrow.png';
import { useState, useEffect, useContext } from 'react';
import { GlobalContext } from 'GlobalContext';
import { USDollar, parsePgArray } from 'utils/format';
import api from 'api';
import { isPhoneSize } from 'utils/util';
import { get } from 'utils/fetch';
import { message, Spin, Input, Select, InputNumber } from 'antd';

export function LoanDetailed() {
    const { manageAssetId, accessToken, assetManager, refreshSession } =
        useContext(GlobalContext);
    const [messageApi, contextHolder] = message.useMessage();
    const { loanId, setLoanId } = assetManager;
    const [loanStatus, setLoanStatus] = useState('');

    // table values
    const [outstandingLoanAmount, setOutstandingLoanAmount] = useState(0);
    const [monthlyMortgagePayment, setMonthlyMortgagePayment] = useState(0);
    const [loanPrepayRestriction, setLoanPrepayRestriction] = useState('');
    const [loanServiceCompany, setLoanServiceCompany] = useState('');
    const [loanType, setLoanType] = useState([]);
    const [rehabLoanBudget, setRehabLoanBudget] = useState(0);
    const [releasedRehabLoan, setReleasedRehabLoan] = useState(0);
    const [lien, setLien] = useState(0);
    const [impound, setImpound] = useState('');
    const [loanAmount, setLoanAmount] = useState(0);
    const [lender, setLender] = useState('');
    const [rate, setRate] = useState(0);
    const [maturityDate, setMaturityDate] = useState(null);

    const [loanAmount2, setLoanAmount2] = useState(0);
    const [lender2, setLender2] = useState('');
    const [rate2, setRate2] = useState(0);
    const [maturityDate2, setMaturityDate2] = useState(null);

    const [loanAmount3, setLoanAmount3] = useState(0);
    const [lender3, setLender3] = useState('');
    const [rate3, setRate3] = useState(0);
    const [maturityDate3, setMaturityDate3] = useState(null);

    const [loanAmount4, setLoanAmount4] = useState(0);
    const [lender4, setLender4] = useState('');
    const [rate4, setRate4] = useState(0);
    const [maturityDate4, setMaturityDate4] = useState(null);

    const [editMode, setEditMode] = useState(false);
    const [loading, setLoading] = useState(loanId === -1 ? false : true);
    const [loan, setLoan] = useState(null);

    const displayErrorMessage = (message) => {
        messageApi.open({
            type: 'error',
            content: message,
        });
    };

    async function fetchLoanInfo(loanId) {
        await get(
            api.asset.getLoan(loanId),
            setLoan,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
        setLoading(false);
    }

    function restore() {
        setLoanStatus(loan.loan_status);
        setOutstandingLoanAmount(loan.outstanding_loan_amount);
        setMonthlyMortgagePayment(loan.monthly_mortgage_payment);
        setLoanPrepayRestriction(loan.loan_prepay_restriction);
        setLoanServiceCompany(loan.loan_service_company);
        setLoanType(parsePgArray(loan.loan_type));
        setRehabLoanBudget(loan.rehab_loan_budget);
        setReleasedRehabLoan(loan.released_rehab_loan);
        setLien(loan.lien);
        setImpound(loan.impound);

        setLoanAmount(loan.loan_amount);
        setLender(loan.lender);
        setRate(loan.rate);
        setMaturityDate(loan.maturity_date);

        setLoanAmount2(loan.loan_amount_2);
        setLender2(loan.lender_2);
        setRate2(loan.rate_2);
        setMaturityDate2(loan.maturity_date_2);

        setLoanAmount3(loan.loan_amount_3);
        setLender3(loan.lender_3);
        setRate3(loan.rate_3);
        setMaturityDate3(loan.maturity_date_3);

        setLoanAmount4(loan.loan_amount_4);
        setLender4(loan.lender_4);
        setRate4(loan.rate_4);
        setMaturityDate4(loan.maturity_date_4);
    }

    useEffect(() => {
        if (loan) {
            restore();
        }
    }, [loan]);

    useEffect(() => {
        if (loanId <= 0) {
            return;
        }
        fetchLoanInfo(loanId);
    }, [loanId]);

    useEffect(() => {
        if (loanId === -1) {
            setEditMode(true); // auto-enable editing when adding
        } else {
            setEditMode(false); // disable editing until user clicks "Edit"
        }
    }, [loanId]);

    function unchanged() {
        if (loanId === -1) {
            return false;
        }
        return (
            loanStatus === loan.loan_status &&
            outstandingLoanAmount === loan.outstanding_loan_amount &&
            monthlyMortgagePayment === loan.monthly_mortgage_payment &&
            loanPrepayRestriction === loan.loan_prepay_restriction &&
            loanServiceCompany === loan.loan_service_company &&
            loanType === loan.loan_type &&
            rehabLoanBudget === loan.rehab_loan_budget &&
            releasedRehabLoan === loan.released_rehab_loan &&
            loanAmount === loan.loan_amount &&
            lender === loan.lender &&
            rate === loan.rate &&
            maturityDate === loan.maturity_date &&
            lien === loan.lien &&
            impound === loan.impound
        );
    }

    async function upsert() {
        if (unchanged()) return;
        setLoading(true);
        const body = JSON.stringify({
            manageAssetId,
            loanStatus,
            outstandingLoanAmount,
            monthlyMortgagePayment,
            loanPrepayRestriction,
            loanServiceCompany,
            loanType,
            rehabLoanBudget,
            releasedRehabLoan,
            lien,
            impound,

            loanAmount,
            lender,
            rate,
            maturityDate,

            loanAmount2,
            lender2,
            rate2,
            maturityDate2,

            loanAmount3,
            lender3,
            rate3,
            maturityDate3,

            loanAmount4,
            lender4,
            rate4,
            maturityDate4,
        });

        const options = {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
            },
            body,
        };
        const response = await fetch(api.asset.upsertLoan(loanId), options);
        const data = await response.json();
        const idRes = data.data;
        refreshSession();
        if (idRes === 0) {
            messageApi.error({
                type: 'error', // or 'error', 'info', 'warning', 'loading'
                content:
                    loanId === -1
                        ? 'Loan insertion failed'
                        : 'Loan update failed',
                duration: 3, // seconds (optional)
            });
            setLoanId(0);
        } else {
            messageApi.open({
                type: 'success', // or 'error', 'info', 'warning', 'loading'
                content:
                    loanId === -1
                        ? 'Loan insertion success'
                        : 'Loan update success',
                duration: 3, // seconds (optional)
            });
            setLoanId(idRes);
            fetchLoanInfo(idRes);
        }
        setEditMode(false);
    }

    async function deleteLoan() {
        setLoading(true);

        const options = {
            method: 'DELETE',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
            },
        };

        const response = await fetch(api.asset.deleteLoan(loanId), options);
        const data = await response.json();
        const idRes = data.data;
        refreshSession();

        if (idRes === 0) {
            messageApi.error({
                type: 'error',
                content: 'Loan deletion failed',
                duration: 3,
            });
        } else {
            messageApi.open({
                type: 'success',
                content: 'Loan deletion success',
                duration: 3,
            });
            setLoanId(0);
        }
    }

    const entryStyle = {
        margin: '20px',
        fontSize: '20px',
    };

    const inputStyle = {
        border: '0',
        outline: 'none',
        borderBottom: '1px solid black',
        fontSize: '20px',
        background: 'transparent',
    };

    return (
        <>
            {contextHolder}
            {loading && (
                <div style={{ marginTop: '30px', textAlign: 'center' }}>
                    <Spin />
                </div>
            )}
            {!loading && (
                <>
                    <div
                        style={{
                            display: 'flex',
                            marginLeft: '20px',
                            position: 'fixed',
                            background: 'white',
                            width: '100%',
                            zIndex: 1,
                            height: '40px',
                            alignItems: 'end',
                        }}
                    >
                        <img
                            style={{
                                width: '15px',
                                height: '20px',
                                cursor: 'pointer',
                            }}
                            src={backArrow}
                            onClick={() => {
                                setLoanId(0);
                            }}
                        ></img>
                        {loanId !== -1 && (
                            <div
                                style={{
                                    width: 'fit-content',
                                    color: 'blue',
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                    marginLeft: '20px',
                                }}
                                onClick={() => {
                                    if (editMode) {
                                        restore();
                                    }
                                    setEditMode((prev) => !prev);
                                }}
                            >
                                {editMode ? 'Restore' : 'Edit'}
                            </div>
                        )}
                    </div>
                    <div style={{ paddingTop: '20px' }}>
                        <div
                            style={
                                isPhoneSize()
                                    ? entryStyle
                                    : {
                                          ...entryStyle,
                                          display: 'flex',
                                          marginTop: '40px',
                                      }
                            }
                        >
                            <div>Loan Status: </div>
                            {editMode ? (
                                <Select
                                    showSearch
                                    placeholder="Select a status"
                                    value={loanStatus}
                                    filterOption={(input, option) =>
                                        (option?.label ?? '')
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                    }
                                    style={{ width: '200px' }}
                                    onChange={(e) => setLoanStatus(e)}
                                    options={[
                                        '',
                                        'Purchase pending',
                                        'Refi pending',
                                        'Active',
                                        'Closed',
                                    ].map((status) => {
                                        return {
                                            value: status,
                                            label: status,
                                        };
                                    })}
                                />
                            ) : (
                                <div>{loanStatus}</div>
                            )}
                        </div>

                        <div
                            style={
                                isPhoneSize()
                                    ? entryStyle
                                    : { ...entryStyle, display: 'flex' }
                            }
                        >
                            <div>Outstanding Loan Amount: </div>
                            {editMode ? (
                                <InputNumber
                                    style={{
                                        ...inputStyle,
                                        width: 'auto',
                                        border: 'none',
                                        borderRadius: 0,
                                        boxShadow: 'none',
                                    }}
                                    value={outstandingLoanAmount}
                                    onChange={(value) => {
                                        setOutstandingLoanAmount(value);
                                    }}
                                    controls={false}
                                    placeholder="outstanding loan amount"
                                />
                            ) : (
                                <div>
                                    {USDollar.format(outstandingLoanAmount)}
                                </div>
                            )}
                        </div>

                        <div
                            style={
                                isPhoneSize()
                                    ? entryStyle
                                    : { ...entryStyle, display: 'flex' }
                            }
                        >
                            <div>Monthly Mortgage Payment: </div>
                            {editMode ? (
                                <InputNumber
                                    style={{
                                        ...inputStyle,
                                        width: 'auto',
                                        border: 'none',
                                        borderRadius: 0,
                                        boxShadow: 'none',
                                    }}
                                    value={monthlyMortgagePayment}
                                    onChange={(value) => {
                                        setMonthlyMortgagePayment(value);
                                    }}
                                    controls={false}
                                    placeholder="monthly mortgage payment"
                                />
                            ) : (
                                <div>
                                    {USDollar.format(monthlyMortgagePayment)}
                                </div>
                            )}
                        </div>

                        <div
                            style={
                                isPhoneSize()
                                    ? entryStyle
                                    : { ...entryStyle, display: 'flex' }
                            }
                        >
                            <div>Loan Prepay Restriction: </div>
                            {editMode ? (
                                <input
                                    style={{
                                        outline: 'none',
                                        border: 0,
                                        borderBottom: '1px solid black',
                                    }}
                                    type="text"
                                    value={loanPrepayRestriction || ''}
                                    onInput={(e) => {
                                        const value = e.target.value;
                                        setLoanPrepayRestriction(value);
                                    }}
                                ></input>
                            ) : (
                                <div>{loanPrepayRestriction}</div>
                            )}
                        </div>

                        <div
                            style={
                                isPhoneSize()
                                    ? entryStyle
                                    : { ...entryStyle, display: 'flex' }
                            }
                        >
                            <div>Loan Service Company: </div>
                            {editMode ? (
                                <input
                                    style={{
                                        outline: 'none',
                                        border: 0,
                                        borderBottom: '1px solid black',
                                    }}
                                    type="text"
                                    value={loanServiceCompany || ''}
                                    onInput={(e) => {
                                        const value = e.target.value;
                                        setLoanServiceCompany(value);
                                    }}
                                ></input>
                            ) : (
                                <div>{loanServiceCompany}</div>
                            )}
                        </div>

                        <div
                            style={
                                isPhoneSize()
                                    ? entryStyle
                                    : { ...entryStyle, display: 'flex' }
                            }
                        >
                            <div>Loan Type: </div>
                            {editMode ? (
                                <Select
                                    mode="multiple"
                                    showSearch
                                    placeholder="Select loan types"
                                    value={loanType}
                                    style={{ width: 200 }}
                                    onChange={(selected) =>
                                        setLoanType(selected)
                                    }
                                    options={[
                                        'None',
                                        'Purchase',
                                        'Bridge',
                                        'New Construction Loan',
                                        '2 Phase loan',
                                        'Private lender',
                                        'ADU',
                                        'Rehab',
                                        'All Cash',
                                        'Extension',
                                        'Bank Statement',
                                        'DSCR',
                                        'Conventional loan',
                                        'Combined Loan',
                                        'Commercial',
                                    ].map((status) => ({
                                        value: status, // usually lowercase for value
                                        label: status, // display label
                                    }))}
                                />
                            ) : (
                                <div>{loanType}</div>
                            )}
                        </div>

                        <div
                            style={
                                isPhoneSize()
                                    ? entryStyle
                                    : { ...entryStyle, display: 'flex' }
                            }
                        >
                            <div>Rehab Loan Budget: </div>
                            {editMode ? (
                                <InputNumber
                                    style={{
                                        ...inputStyle,
                                        width: 'auto',
                                        border: 'none',
                                        borderRadius: 0,
                                        boxShadow: 'none',
                                    }}
                                    value={rehabLoanBudget}
                                    onChange={(value) => {
                                        setRehabLoanBudget(value);
                                    }}
                                    controls={false}
                                    placeholder="rehab loan budget"
                                />
                            ) : (
                                <div>{USDollar.format(rehabLoanBudget)}</div>
                            )}
                        </div>

                        <div
                            style={
                                isPhoneSize()
                                    ? entryStyle
                                    : { ...entryStyle, display: 'flex' }
                            }
                        >
                            <div>Released Rehab Loan: </div>
                            {editMode ? (
                                <InputNumber
                                    style={{
                                        ...inputStyle,
                                        width: 'auto',
                                        border: 'none',
                                        borderRadius: 0,
                                        boxShadow: 'none',
                                    }}
                                    value={releasedRehabLoan}
                                    onChange={(value) => {
                                        setReleasedRehabLoan(value);
                                    }}
                                    controls={false}
                                    placeholder="released rehab loan"
                                />
                            ) : (
                                <div>{USDollar.format(releasedRehabLoan)}</div>
                            )}
                        </div>

                        <div
                            style={
                                isPhoneSize()
                                    ? entryStyle
                                    : { ...entryStyle, display: 'flex' }
                            }
                        >
                            <div>Lien: </div>
                            {editMode ? (
                                <InputNumber
                                    style={{
                                        ...inputStyle,
                                        width: 'auto',
                                        border: 'none',
                                        borderRadius: 0,
                                        boxShadow: 'none',
                                    }}
                                    value={lien}
                                    onChange={(value) => {
                                        setLien(value);
                                    }}
                                    controls={false}
                                    placeholder="lien"
                                />
                            ) : (
                                <div>{USDollar.format(lien)}</div>
                            )}
                        </div>

                        <div
                            style={
                                isPhoneSize()
                                    ? entryStyle
                                    : { ...entryStyle, display: 'flex' }
                            }
                        >
                            <div>Impound:</div>
                            {editMode ? (
                                <Select
                                    placeholder="Select yes or no"
                                    value={
                                        impound === null
                                            ? undefined
                                            : impound.toString()
                                    }
                                    style={{ width: '200px' }}
                                    onChange={(value) =>
                                        setImpound(value === 'true')
                                    }
                                    options={[
                                        { value: 'true', label: 'Yes' },
                                        { value: 'false', label: 'No' },
                                    ]}
                                />
                            ) : (
                                <div>{impound ? 'Yes' : 'No'}</div>
                            )}
                        </div>

                        <div
                            style={
                                isPhoneSize()
                                    ? entryStyle
                                    : { ...entryStyle, display: 'flex' }
                            }
                        >
                            <div>Loan Amount (1st): </div>
                            {editMode ? (
                                <InputNumber
                                    style={{
                                        ...inputStyle,
                                        width: 'auto',
                                        border: 'none',
                                        borderRadius: 0,
                                        boxShadow: 'none',
                                    }}
                                    value={loanAmount}
                                    onChange={(value) => {
                                        setLoanAmount(value);
                                    }}
                                    controls={false}
                                    placeholder="1st loan amount"
                                />
                            ) : (
                                <div>{USDollar.format(loanAmount)}</div>
                            )}
                        </div>

                        <div
                            style={
                                isPhoneSize()
                                    ? entryStyle
                                    : { ...entryStyle, display: 'flex' }
                            }
                        >
                            <div>Lender (1st): </div>
                            {editMode ? (
                                <input
                                    style={{
                                        outline: 'none',
                                        border: 0,
                                        borderBottom: '1px solid black',
                                    }}
                                    type="text"
                                    value={lender || ''}
                                    onInput={(e) => {
                                        const value = e.target.value;
                                        setLender(value);
                                    }}
                                ></input>
                            ) : (
                                <div>{lender}</div>
                            )}
                        </div>

                        <div
                            style={
                                isPhoneSize()
                                    ? entryStyle
                                    : { ...entryStyle, display: 'flex' }
                            }
                        >
                            <div>Rate (1st): </div>
                            {editMode ? (
                                <InputNumber
                                    style={{
                                        ...inputStyle,
                                        width: 'auto',
                                        border: 'none',
                                        borderRadius: 0,
                                        boxShadow: 'none',
                                    }}
                                    value={rate}
                                    onChange={(value) => {
                                        setRate(value);
                                    }}
                                    controls={false}
                                    placeholder="1st rate"
                                />
                            ) : (
                                <div>
                                    {rate ? `${Number(rate).toFixed(3)}%` : ''}
                                </div>
                            )}
                        </div>

                        <div
                            style={
                                isPhoneSize()
                                    ? entryStyle
                                    : { ...entryStyle, display: 'flex' }
                            }
                        >
                            <div>Maturity Date (1st): </div>
                            {editMode ? (
                                <input
                                    type="date"
                                    style={{
                                        outline: 'none',
                                        border: 0,
                                        borderBottom: '1px solid black',
                                    }}
                                    value={maturityDate || ''}
                                    onChange={(e) =>
                                        setMaturityDate(e.target.value)
                                    }
                                ></input>
                            ) : (
                                <div>{maturityDate}</div>
                            )}
                        </div>

                        <div
                            style={
                                isPhoneSize()
                                    ? entryStyle
                                    : { ...entryStyle, display: 'flex' }
                            }
                        >
                            <div>Loan Amount (2nd): </div>
                            {editMode ? (
                                <InputNumber
                                    style={{
                                        ...inputStyle,
                                        width: 'auto',
                                        border: 'none',
                                        borderRadius: 0,
                                        boxShadow: 'none',
                                    }}
                                    value={loanAmount2}
                                    onChange={(value) => {
                                        setLoanAmount2(value);
                                    }}
                                    controls={false}
                                    placeholder="2nd loan amount"
                                />
                            ) : (
                                <div>{USDollar.format(loanAmount2)}</div>
                            )}
                        </div>

                        <div
                            style={
                                isPhoneSize()
                                    ? entryStyle
                                    : { ...entryStyle, display: 'flex' }
                            }
                        >
                            <div>Lender (2nd): </div>
                            {editMode ? (
                                <input
                                    style={{
                                        outline: 'none',
                                        border: 0,
                                        borderBottom: '1px solid black',
                                    }}
                                    type="text"
                                    value={lender2 || ''}
                                    onInput={(e) => {
                                        const value = e.target.value;
                                        setLender2(value);
                                    }}
                                ></input>
                            ) : (
                                <div>{lender2}</div>
                            )}
                        </div>

                        <div
                            style={
                                isPhoneSize()
                                    ? entryStyle
                                    : { ...entryStyle, display: 'flex' }
                            }
                        >
                            <div>Rate (2nd): </div>
                            {editMode ? (
                                <InputNumber
                                    style={{
                                        ...inputStyle,
                                        width: 'auto',
                                        border: 'none',
                                        borderRadius: 0,
                                        boxShadow: 'none',
                                    }}
                                    value={rate2}
                                    onChange={(value) => {
                                        setRate2(value);
                                    }}
                                    controls={false}
                                    placeholder="2nd rate"
                                />
                            ) : (
                                <div>
                                    {rate2
                                        ? `${Number(rate2).toFixed(3)}%`
                                        : ''}
                                </div>
                            )}
                        </div>

                        <div
                            style={
                                isPhoneSize()
                                    ? entryStyle
                                    : { ...entryStyle, display: 'flex' }
                            }
                        >
                            <div>Maturity Date (2nd): </div>
                            {editMode ? (
                                <input
                                    type="date"
                                    style={{
                                        outline: 'none',
                                        border: 0,
                                        borderBottom: '1px solid black',
                                    }}
                                    value={maturityDate2 || ''}
                                    onChange={(e) =>
                                        setMaturityDate2(e.target.value)
                                    }
                                ></input>
                            ) : (
                                <div>{maturityDate2}</div>
                            )}
                        </div>

                        <div
                            style={
                                isPhoneSize()
                                    ? entryStyle
                                    : { ...entryStyle, display: 'flex' }
                            }
                        >
                            <div>Loan Amount (3rd): </div>
                            {editMode ? (
                                <InputNumber
                                    style={{
                                        ...inputStyle,
                                        width: 'auto',
                                        border: 'none',
                                        borderRadius: 0,
                                        boxShadow: 'none',
                                    }}
                                    value={loanAmount3}
                                    onChange={(value) => {
                                        setLoanAmount3(value);
                                    }}
                                    controls={false}
                                    placeholder="3rd loan amount"
                                />
                            ) : (
                                <div>{USDollar.format(loanAmount3)}</div>
                            )}
                        </div>

                        <div
                            style={
                                isPhoneSize()
                                    ? entryStyle
                                    : { ...entryStyle, display: 'flex' }
                            }
                        >
                            <div>Lender (3rd): </div>
                            {editMode ? (
                                <input
                                    style={{
                                        outline: 'none',
                                        border: 0,
                                        borderBottom: '1px solid black',
                                    }}
                                    type="text"
                                    value={lender3 || ''}
                                    onInput={(e) => {
                                        const value = e.target.value;
                                        setLender3(value);
                                    }}
                                ></input>
                            ) : (
                                <div>{lender3}</div>
                            )}
                        </div>

                        <div
                            style={
                                isPhoneSize()
                                    ? entryStyle
                                    : { ...entryStyle, display: 'flex' }
                            }
                        >
                            <div>Rate (3rd): </div>
                            {editMode ? (
                                <InputNumber
                                    style={{
                                        ...inputStyle,
                                        width: 'auto',
                                        border: 'none',
                                        borderRadius: 0,
                                        boxShadow: 'none',
                                    }}
                                    value={rate3}
                                    onChange={(value) => {
                                        setRate3(value);
                                    }}
                                    controls={false}
                                    placeholder="3rd rate"
                                />
                            ) : (
                                <div>
                                    {rate3
                                        ? `${Number(rate3).toFixed(3)}%`
                                        : ''}
                                </div>
                            )}
                        </div>

                        <div
                            style={
                                isPhoneSize()
                                    ? entryStyle
                                    : { ...entryStyle, display: 'flex' }
                            }
                        >
                            <div>Maturity Date (3rd): </div>
                            {editMode ? (
                                <input
                                    type="date"
                                    style={{
                                        outline: 'none',
                                        border: 0,
                                        borderBottom: '1px solid black',
                                    }}
                                    value={maturityDate3 || ''}
                                    onChange={(e) =>
                                        setMaturityDate3(e.target.value)
                                    }
                                ></input>
                            ) : (
                                <div>{maturityDate3}</div>
                            )}
                        </div>

                        <div
                            style={
                                isPhoneSize()
                                    ? entryStyle
                                    : { ...entryStyle, display: 'flex' }
                            }
                        >
                            <div>Loan Amount (4th): </div>
                            {editMode ? (
                                <InputNumber
                                    style={{
                                        ...inputStyle,
                                        width: 'auto',
                                        border: 'none',
                                        borderRadius: 0,
                                        boxShadow: 'none',
                                    }}
                                    value={loanAmount4}
                                    onChange={(value) => {
                                        setLoanAmount4(value);
                                    }}
                                    controls={false}
                                    placeholder="4th loan amount"
                                />
                            ) : (
                                <div>{USDollar.format(loanAmount4)}</div>
                            )}
                        </div>

                        <div
                            style={
                                isPhoneSize()
                                    ? entryStyle
                                    : { ...entryStyle, display: 'flex' }
                            }
                        >
                            <div>Lender (4th): </div>
                            {editMode ? (
                                <input
                                    style={{
                                        outline: 'none',
                                        border: 0,
                                        borderBottom: '1px solid black',
                                    }}
                                    type="text"
                                    value={lender4 || ''}
                                    onInput={(e) => {
                                        const value = e.target.value;
                                        setLender4(value);
                                    }}
                                ></input>
                            ) : (
                                <div>{lender4}</div>
                            )}
                        </div>

                        <div
                            style={
                                isPhoneSize()
                                    ? entryStyle
                                    : { ...entryStyle, display: 'flex' }
                            }
                        >
                            <div>Rate (4th): </div>
                            {editMode ? (
                                <InputNumber
                                    style={{
                                        ...inputStyle,
                                        width: 'auto',
                                        border: 'none',
                                        borderRadius: 0,
                                        boxShadow: 'none',
                                    }}
                                    value={rate4}
                                    onChange={(value) => {
                                        setRate4(value);
                                    }}
                                    controls={false}
                                    placeholder="4th rate"
                                />
                            ) : (
                                <div>
                                    {rate4
                                        ? `${Number(rate4).toFixed(3)}%`
                                        : ''}
                                </div>
                            )}
                        </div>

                        <div
                            style={
                                isPhoneSize()
                                    ? entryStyle
                                    : { ...entryStyle, display: 'flex' }
                            }
                        >
                            <div>Maturity Date (4th): </div>
                            {editMode ? (
                                <input
                                    type="date"
                                    style={{
                                        outline: 'none',
                                        border: 0,
                                        borderBottom: '1px solid black',
                                    }}
                                    value={maturityDate4 || ''}
                                    onChange={(e) =>
                                        setMaturityDate4(e.target.value)
                                    }
                                ></input>
                            ) : (
                                <div>{maturityDate4}</div>
                            )}
                        </div>
                    </div>

                    <div style={{ display: 'flex', marginLeft: '20px' }}>
                        <button
                            style={{
                                height: '30px',
                                width: '60px',
                                borderRadius: '30px',
                                background: 'rgb(17 32 86)',
                                color: 'white',
                                cursor: 'pointer',
                            }}
                            onClick={upsert}
                        >
                            Save
                        </button>
                        <button
                            style={{
                                height: '30px',
                                width: '60px',
                                borderRadius: '30px',
                                background: 'rgb(86 17 17)',
                                color: 'white',
                                cursor: 'pointer',
                            }}
                            onClick={() => {
                                if (
                                    window.confirm(
                                        'Are you sure you want to delete this loan?'
                                    )
                                ) {
                                    deleteLoan();
                                }
                            }}
                        >
                            Delete
                        </button>
                    </div>
                </>
            )}
        </>
    );
}
